import { dDay } from '@zelos/shared/lib/date-util';
import type { Dayjs } from 'dayjs';
import { memo } from 'react';
import Chip from './Chip';
import { colors } from '@/constants/colors';
import { interFontFamily } from '@/lib/fonts';

const DdayChip = ({ date }: { date?: string | Dayjs }) => (
  <Chip
    txt={dDay(date)}
    textColor={colors.blue}
    backgroundColor={colors.blue25}
    fontFamily={interFontFamily}
    fontSize="12px"
    height="24px"
    size="small"
  />
);

export default memo(DdayChip);
